import { type ReactNode } from "react";

import { Text } from "../Text";

export interface InformationSectionSubtitleContentProps {
  children: ReactNode;
}

export function InformationSectionSubtitleContent({
  children,
}: InformationSectionSubtitleContentProps) {
  return (
    <Text semibold variant="body1" mb={1} sx={{ lineHeight: 1.25 }}>
      {children}
    </Text>
  );
}
